import React from 'react';
import styled from 'styled-components';

import { Field } from 'react-final-form';
import { Box as MuiBox, useTheme } from '@mui/material';

import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as CircleIcon
} from '@mui/icons-material';

const FormDefaultRadio = ({ name, value, width = '100%' }) => {

  const theme = useTheme()
  
  return (
    <Field
      type="radio"
      value={value}
      name={name}
    >
      {({ input, meta }) => (
        <SCheckboxWrapper width={width} onClick={() => input.onChange(value)}>
          {input.checked
            ? <CheckCircleIcon style={{color: theme.palette.colors.blue100}} />
            : <CircleIcon style={{color: theme.palette.colors.gray300}} />
          }
        </SCheckboxWrapper>
      )}
    </Field>
  )
}

const SCheckboxWrapper = styled(MuiBox)`
  display: flex;
  width: ${({width}) => width};
  cursor: pointer;
  justify-content: center;
  align-items: center;
`

export default FormDefaultRadio;
